<div class="container-fluid p-3">
    <h4 class="fw-bold">Municipal Commissioner Dashboard</h4>
    <p>Grievance Redressal System-Executive Overview</p>

    <div class="row g-3 mb-4">
        <div class="col-md-4 col-12 col-sm-6">
            <a [routerLink]="['/sdp/mc/total-greviance']" class="text-decoration-none text-dark">
                <div class="card text-white h-100 cardfirst">
                    <div class="card-body gap-3 d-flex align-items-center justify-content-between">
                        <div>
                            <h5>Total Grievances</h5>
                            <h4>{{ summary.totalGrievances | number }}</h4>
                        </div>
                        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                            <g clip-path="url(#clip0_169_5179)">
                                <path
                                    d="M28.3327 35V31.6667C28.3327 29.8986 27.6303 28.2029 26.3801 26.9526C25.1298 25.7024 23.4341 25 21.666 25H8.33268C6.56457 25 4.86888 25.7024 3.61864 26.9526C2.36839 28.2029 1.66602 29.8986 1.66602 31.6667V35M38.3327 35V31.6667C38.3316 30.1895 37.8399 28.7546 36.935 27.5872C36.03 26.4198 34.7629 25.5859 33.3327 25.2167M26.666 5.21667C28.1 5.58384 29.3711 6.41783 30.2787 7.58718C31.1864 8.75653 31.6791 10.1947 31.6791 11.675C31.6791 13.1553 31.1864 14.5935 30.2787 15.7628C29.3711 16.9322 28.1 17.7662 26.666 18.1333M21.666 11.6667C21.666 15.3486 18.6812 18.3333 14.9993 18.3333C11.3175 18.3333 8.33268 15.3486 8.33268 11.6667C8.33268 7.98477 11.3175 5 14.9993 5C18.6812 5 21.666 7.98477 21.666 11.6667Z"
                                    stroke="white" stroke-opacity="0.7" stroke-width="3.5" stroke-linecap="round"
                                    stroke-linejoin="round" />
                            </g>
                            <defs>
                                <clipPath id="clip0_169_5179">
                                    <rect width="40" height="40" fill="white" />
                                </clipPath>
                            </defs>
                        </svg>
                    </div>
                </div>
            </a>
        </div>

        <div class="col-md-4 col-12 col-sm-6">
            <a [routerLink]="['/sdp/mc/pending-mc']" class="text-decoration-none text-dark">

                <div class="card text-white bg-success h-100 cardsecond">
                    <div class="card-body d-flex align-items-center justify-content-between gap-3">
                        <div>
                            <h5>Pending</h5>
                            <h4>{{ summary.pending | number }}</h4>
                        </div>
                        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                            <path
                                d="M20.0007 10V20L26.6673 23.3333M36.6673 20C36.6673 29.2048 29.2054 36.6667 20.0007 36.6667C10.7959 36.6667 3.33398 29.2048 3.33398 20C3.33398 10.7953 10.7959 3.33334 20.0007 3.33334C29.2054 3.33334 36.6673 10.7953 36.6673 20Z"
                                stroke="white" stroke-opacity="0.7" stroke-width="3.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                    </div>
                </div>
            </a>
        </div>

        <div class="col-md-4 col-12 col-sm-6">
            <a [routerLink]="['/sdp/officer/resolved-complaints']" class="text-decoration-none text-dark">

                <div class="card text-white bg-warning h-100 cardthird">
                    <div class="card-body d-flex align-items-center justify-content-between gap-3">
                        <div>
                            <h5>Resolved</h5>
                            <h4>{{ summary.resolved | number }}</h4>
                        </div>
                        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                            <path
                                d="M36.6654 18.4667V20C36.6633 23.594 35.4995 27.0911 33.3476 29.9697C31.1956 32.8483 28.1708 34.9541 24.7243 35.9732C21.2777 36.9922 17.5941 36.8698 14.2228 35.6243C10.8515 34.3788 7.97312 32.0768 6.01697 29.0618C4.06081 26.0467 3.13168 22.4801 3.36816 18.8939C3.60464 15.3076 4.99404 11.8939 7.32916 9.16179C9.66429 6.4297 12.82 4.52563 16.3257 3.73357C19.8314 2.94151 23.4991 3.30389 26.782 4.76667M36.6654 6.66667L19.9987 23.35L14.9987 18.35"
                                stroke="white" stroke-opacity="0.7" stroke-width="3.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                    </div>
                </div>
            </a>
        </div>
        <div class="col-md-4 col-12 col-sm-6">
 
            <a [routerLink]="['/sdp/officer/closed-complaints']" class="text-decoration-none text-dark">

                <div class="card text-white bg-danger h-100 cardfourt">
                    <div class="card-body d-flex align-items-center justify-content-between gap-3">
                        <div>
                            <h5>Closed</h5>
                            <h4>{{ summary.closed | number }}</h4>
                        </div>
                        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                            <path
                                d="M19.9987 3.33333L25.1487 13.7667L36.6654 15.45L28.332 23.5667L30.2987 35.0333L19.9987 29.6167L9.6987 35.0333L11.6654 23.5667L3.33203 15.45L14.8487 13.7667L19.9987 3.33333Z"
                                stroke="white" stroke-opacity="0.7" stroke-width="3.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                    </div>
 
                </div>
            </a>
        </div>
        <div class="col-md-4 col-12 col-sm-6">
            <a [routerLink]="['/sdp/officer/escalated-complaints']" class="text-decoration-none text-dark">

                <div class="card text-white bg-danger h-100 cardfourth">
                    <div class="card-body d-flex align-items-center justify-content-between gap-3">
                        <div>
                            <h5>Escalated</h5>
                            <h4>{{ summary.escalated | number }}</h4>
                        </div>
                        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                            <path
                                d="M19.9993 15V21.6667M19.9993 28.3333H20.016M17.1493 6.43334L3.03264 30C2.74158 30.504 2.58758 31.0755 2.58595 31.6575C2.58432 32.2396 2.73512 32.8119 3.02335 33.3175C3.31157 33.8232 3.72718 34.2446 4.22882 34.5398C4.73045 34.8349 5.30063 34.9936 5.88264 35H34.116C34.698 34.9936 35.2681 34.8349 35.7698 34.5398C36.2714 34.2446 36.687 33.8232 36.9753 33.3175C37.2635 32.8119 37.4143 32.2396 37.4127 31.6575C37.411 31.0755 37.257 30.504 36.966 30L22.8493 6.43334C22.5522 5.94352 22.1338 5.53854 21.6346 5.25748C21.1354 4.97642 20.5722 4.82877 19.9993 4.82877C19.4264 4.82877 18.8632 4.97642 18.364 5.25748C17.8648 5.53854 17.4464 5.94352 17.1493 6.43334Z"
                                stroke="white" stroke-opacity="0.7" stroke-width="3.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                    </div>
                </div>
            </a>
        </div>
        <div class="col-md-4 col-12 col-sm-6">
                        <a [routerLink]="['/sdp/mc/today-greviance']" class="text-decoration-none text-dark">

            <div class="card text-white bg-danger h-100 cardfifth">
                <div class="card-body d-flex align-items-center justify-content-between gap-3">
                    <div>
                        <h5>Today Registered</h5>
                        <h4>{{ summary.today }}</h4>
                    </div>
                    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                        <g clip-path="url(#clip0_169_5204)">
                            <path
                                d="M38.3327 10L22.4993 25.8333L14.166 17.5L1.66602 30M38.3327 10H28.3327M38.3327 10L38.3327 20"
                                stroke="white" stroke-opacity="0.7" stroke-width="3.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </g>
                        <defs>
                            <clipPath id="clip0_169_5204">
                                <rect width="40" height="40" fill="white" />
                            </clipPath>
                        </defs>
                    </svg>
                </div>
            </div>
                        </a>
        </div>
    </div>

    <div class="row mt-3">
        <div class="col-12">
            <div class="card bg-white p-3">
                <div class="card-header fw-bold bg-white border-0">
                    Department-Wise Performance
                </div>

                <div class="bg-light p-3 rounded mb-3" *ngFor="let dept of departments">
                    <div class="row justify-content-center  align-items-center">

                        <div class="col-lg-3  col-12 departmentspart mb-3">
                            <div class="department-title">{{ dept.department_name }}</div>
                            <div class="department-stats">Total: {{ dept.total_complaints }}</div>
                            <div class="department-stats">Resolved: {{ dept.resolved_complaints }}</div>
                        </div>
                        <div class="col-lg-4 col-md-6 d-flex flex-column mx-2 mx-md-3 mx-lg-4  align-items-start">
                            <div class="resolution-rate">Resolution Rate</div>
                            <div class="progress-wrapper position-relative">
                                <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="13" viewBox="0 0 231 13"
                                    fill="none">
                                    <rect x="0.5" y="0.5" width="230" height="12" rx="6" fill="#CACACA" />
                                    <path [attr.d]="calculatePath(dept.resolutionRate)" fill="black" />
                                </svg>
                                <span class="progress-label" [ngStyle]="getLabelStyle(dept.resolutionRate)">
                                    {{ dept.resolution_rate }}
                                </span>
                            </div>
                        </div>

                        <div class="col-lg-3 d-sm-block mx-2 mx-md-3 mx-lg-4  d-lg-block text-start">
                            <div class="average-label">Average Time</div>
                            <div class="average-value fw-bold">{{ dept.avg_resolution_days }} <span
                                    *ngIf="dept.avg_resolution_days">days</span></div>
                        </div>

                    </div>
                </div>
            </div>

        </div>
    </div>

    <div class="row mt-3">
        <div class="col-12">
            <div class="card bg-white p-3">

                <!-- <div class="row g-3 mb-3 align-items-end">
                    <div class="col-12 col-md-3">
                        <label class="fw-bold d-block">Department</label>
                        <ng-select [items]="departments" placeholder="Select Department" bindLabel="department_name"
                            bindValue="dep_cd" [(ngModel)]="selectedDepartment" (change)="filterGrievanceData()"
                            [clearable]="true" [searchable]="true" class="w-100">
                        </ng-select>
                    </div>

                    <div class="col-12 col-md-3">
                        <label class="fw-bold d-block">Zone</label>
                        <ng-select [items]="zoneArr" bindLabel="zone" bindValue="zone_cd" placeholder="Select Zone"
                            [(ngModel)]="selectedZone" (change)="filterGrievanceData()" [clearable]="true"
                            [searchable]="true" class="w-100">
                        </ng-select>

                    </div>

                    <div class="col-12 col-md-3">
                        <label class="fw-bold d-block">Ward</label>
                        <ng-select [items]="wordArr" bindLabel="word" bindValue="word" placeholder="Select Ward"
                            [(ngModel)]="selectedWard" (change)="filterGrievanceData()" [clearable]="true"
                            [searchable]="true" class="w-100">
                        </ng-select>
                    </div>
                </div> -->

                <div class="card-header fw-bold bg-white border-0 d-flex align-items-center gap-2">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M14.9991 6c..." fill="#226CE0" />
                    </svg>
                    {{ getSelectedViewLabel() }}-Wise Grievance Distribution
                </div>

                <div class="row gx-3 gy-3 mt-3 ">
                    <div class="col-lg-3 col-md-4 col-sm-6" *ngFor="let item of grievancesData">
                        <div class="p-3 rounded text-dark h-100  d-flex flex-column justify-content-center align-items-center text-center"
                            [ngStyle]="{ 'background-color': item.bgColor }" style="min-height: 120px;">
                            <strong>{{ item.department_name }}</strong>
                            <div>Total: {{ item.total_complaints }}</div>
                            <div>Pending: {{ item['pending_complaints'] }}</div>
                            <div class="d-flex align-items-center justify-content-center gap-1 mt-2">
                                 <svg xmlns="http://www.w3.org/2000/svg" width="15" height="14" viewBox="0 0 15 14"
                                    fill="none">
                                    <g clip-path="url(#clip0_453_4592)">
                                        <path
                                            d="M6.50343 2.25166L1.56259 10.5C1.46073 10.6764 1.40682 10.8764 1.40625 11.0801C1.40568 11.2838 1.45846 11.4842 1.55934 11.6611C1.66022 11.8381 1.80568 11.9856 1.98126 12.0889C2.15683 12.1922 2.35639 12.2478 2.56009 12.25H12.4418C12.6455 12.2478 12.845 12.1922 13.0206 12.0889C13.1962 11.9856 13.3416 11.8381 13.4425 11.6611C13.5434 11.4842 13.5962 11.2838 13.5956 11.0801C13.595 10.8764 13.5411 10.6764 13.4393 10.5L8.49843 2.25166C8.39444 2.08023 8.24802 1.93848 8.07329 1.84011C7.89857 1.74174 7.70144 1.69006 7.50093 1.69006C7.30042 1.69006 7.10329 1.74174 6.92856 1.84011C6.75384 1.93848 6.60742 2.08023 6.50343 2.25166Z"
                                            fill="#EAB308" />
                                        <path
                                            d="M7.50093 5.25V7.58333M7.50093 9.91666H7.50676M6.50343 2.25166L1.56259 10.5C1.46073 10.6764 1.40682 10.8764 1.40625 11.0801C1.40568 11.2838 1.45846 11.4842 1.55934 11.6611C1.66022 11.8381 1.80568 11.9856 1.98126 12.0889C2.15683 12.1922 2.35639 12.2478 2.56009 12.25H12.4418C12.6455 12.2478 12.845 12.1922 13.0206 12.0889C13.1962 11.9856 13.3416 11.8381 13.4425 11.6611C13.5434 11.4842 13.5962 11.2838 13.5956 11.0801C13.595 10.8764 13.5411 10.6764 13.4393 10.5L8.49843 2.25166C8.39444 2.08023 8.24802 1.93848 8.07329 1.84011C7.89857 1.74174 7.70144 1.69006 7.50093 1.69006C7.30042 1.69006 7.10329 1.74174 6.92856 1.84011C6.75384 1.93848 6.60742 2.08023 6.50343 2.25166Z"
                                            stroke="#1E1E1E" stroke-linecap="round" stroke-linejoin="round" />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_453_4592">
                                            <rect width="14" height="14" fill="white" transform="translate(0.5)" />
                                        </clipPath>
                                    </defs>
                                </svg>  
                                <span>Escalated {{ item.total_escalated }}</span>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>


    <div class="row mt-3">
        <div class="col-12">
            <div class="card bg-white p-3">
                <div class="card-header fw-bold bg-white border-0">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <path
                            d="M9.99965 7.49993V10.8333M9.99965 14.1666H10.008M8.57465 3.21659L1.51632 14.9999C1.37079 15.2519 1.29379 15.5377 1.29298 15.8287C1.29216 16.1197 1.36756 16.4059 1.51167 16.6587C1.65579 16.9115 1.86359 17.1222 2.11441 17.2698C2.36523 17.4174 2.65032 17.4967 2.94132 17.4999H17.058C17.349 17.4967 17.6341 17.4174 17.8849 17.2698C18.1357 17.1222 18.3435 16.9115 18.4876 16.6587C18.6317 16.4059 18.7071 16.1197 18.7063 15.8287C18.7055 15.5377 18.6285 15.2519 18.483 14.9999L11.4247 3.21659C11.2761 2.97168 11.0669 2.76919 10.8173 2.62866C10.5677 2.48813 10.2861 2.41431 9.99965 2.41431C9.7132 2.41431 9.43159 2.48813 9.18199 2.62866C8.93238 2.76919 8.72321 2.97168 8.57465 3.21659Z"
                            stroke="#F64F4F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                    Escalated Complaints Tracker
                </div>

                <div *ngFor="let complaint of pagedEscalatedComplaints" class="card mb-3">
                    <div class="card-body">
                        <div class="complaintid fw-semibold mb-1">{{ complaint.ticket_id }}</div>
                        <h6 class="card-title fw-bold">{{ complaint.complaint_desc }}</h6>

                        <div class="row align-items-start mt-3 ">
                            <div class="col-12 col-md-9">
                                <div class="row row-cols-1 row-cols-sm-2 row-cols-lg-3 g-4">

                                    <div>
                                        <div class="d-flex align-items-center mb-1">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17"
                                                viewBox="0 0 16 17" fill="none" class="me-2">
                                                <circle cx="8" cy="8.5" r="5.83333" stroke="#787878" />
                                                <path d="M11 8.5H8.25C8.11193 8.5 8 8.38815 8 8.25V6.16675"
                                                    stroke="#787878" stroke-linecap="round" />
                                            </svg>
                                            <span class="text-muted">Generated</span>
                                        </div>
                                        <div class="fw-bold">{{ complaint.generated }}</div>
                                    </div>

                                    <div>
                                        <div class="text-muted mb-1">Department</div>
                                        <div class="fw-bold">{{ complaint.department_name }}</div>
                                    </div>

                                    <div>
                                        <div class="d-flex align-items-center mb-1">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17"
                                                viewBox="0 0 16 17" fill="none" class="me-2">
                                                <circle cx="8" cy="5.16667" r="2.66667" stroke="#787878"
                                                    stroke-linecap="round" />
                                                <path
                                                    d="M3.50721 12.9463C3.93182 10.9292 5.9394 9.83325 8.00065 9.83325V9.83325C10.0619 9.83325 12.0695 10.9292 12.4941 12.9463C12.5414 13.1709 12.5812 13.401 12.6106 13.6341C12.6707 14.1098 12.2786 14.4999 11.7991 14.4999H4.20223C3.72271 14.4999 3.33057 14.1098 3.3907 13.6341C3.42015 13.401 3.45992 13.1709 3.50721 12.9463Z"
                                                    stroke="#787878" stroke-linecap="round" />
                                            </svg>
                                            <span class="text-muted">Assigned Officer</span>
                                        </div>
                                        <div style="font-weight: 700 !important;">{{ complaint.assigned_officer}}
                                        </div>
                                    </div>

                                </div>
                            </div>

                            <div class="col-12 col-md-3 mt-3 mt-md-0 text-md-start">
                                <div class="fw-semibold ">Days Pending</div>
                                <div class="fw-bold text-danger">{{ complaint.days_pending }} </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="d-flex justify-content-between align-items-center mt-3 flex-wrap">
                    <span style="color: #6D6D6D; font-size: 14px; font-weight: 300; line-height: 21px;">
                        Showing {{ pagedEscalatedComplaints.length }} of {{ escalatedComplaints.length }} escalated
                        complaints
                    </span>

                    <div class="d-flex align-items-center gap-2 mt-2 mt-md-0">
                        <label class="me-1">Per page:</label>
                        <select [(ngModel)]="pageSize" (change)="changePageSize()"
                            class="form-select form-select-sm w-auto">
                            <option *ngFor="let size of page_list" [value]="size">{{ size }}</option>
                        </select>

                        <button class="btn-sm fw-bold px-3 py-1  me-2" (click)="prevPage()"
                            [disabled]="currentPage === 1" title="Previous Page">
                            &lt;
                        </button>


                        <span style="font-weight: 600;">{{ currentPage }} / {{ totalPages }}</span>

                        <button class="me-2 btn-sm fw-bold px-3 py-1" (click)="nextPage()"
                            [disabled]="currentPage === totalPages">&gt;</button>
                    </div>

                </div>


            </div>
        </div>
    </div>

</div>